<template>
  <v-dialog
    v-model="activate"
    max-width="900px"
    persistent
  >
    <v-card class="px-4" color="background">
      <v-card-title>
        <vuse-section-definition
          :title="formTitle"
          icon="mdi-domain"
          class="ml-n4 pa-0 pb-4" />
      </v-card-title>
      <v-card-text>
        <v-container class="mb-2 pa-0">
          <v-form ref="companyForm">
            <v-sheet class="neu-glow px-6">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                      v-model="editedItem.name"
                      @input="validate"
                      :label="$t('Global.Companies.companyName')+'*'"
                      :rules="[ requiredRule, limitTo45, validNameCompany ]"
                      counter="45"
                      maxlength="45"
                      required
                      clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="editedItem.description"
                        @input="validate"
                        :label="$t('Global.Companies.description')+'*'"
                        :rules="[ requiredRule, limitTo45 ]"
                        counter="45"
                        maxlength="45"
                        required
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="editedItem.xsiCompanyId"
                        @input="validate"
                        :label="$t('Global.Companies.xsiCompanyId')"
                        :rules="[ requiredRule, limitTo50 ]"
                        counter="50"
                        maxlength="50"
                        required
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                        v-model="editedItem.xsiServiceType"
                        :items="xsiServiceTypeList"
                        @input="validate"
                        item-text="xsiName"
                        item-value="xsiName"
                        :label="$t('Global.Companies.xsiServiceType')+'*'"
                        :rules="[ requiredRule ]"
                        required
                        :menu-props="{ bottom: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="editedItem.licenceExpiration"
                        @change="validate"
                        :label="$t('Global.Companies.licenceExpiration')"
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                        v-model="editedItem.licenseTypeId"
                        :items="licenceTypeList"
                        @input="validate"
                        item-text="licenseTypeName"
                        item-value="licenseTypeId"
                        :label="$t('Global.Companies.licenceTypeId')+'*'"
                        :rules="[ requiredRule ]"
                        required
                        :menu-props="{ bottom: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                        v-model="editedItem.fsCode"
                        @change="validate"
                        :label="$t('Global.Companies.fsCode')+'*'"
                        :rules="[ requiredRule, validFsCode ]"
                        counter="4"
                        maxlength="4"
                        clearable
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="editedItem.email"
                        @input="validate"
                        :label="$t('Global.Companies.email')"
                        :rules="[ validEmail, limitTo45 ]"
                        counter="45"
                        clearable
                    ></v-text-field>
                </v-col>
              </v-row>
            </v-sheet>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">{{ $t('Global.Companies.cancel') }}</v-btn>
        <v-btn color="blue darken-1" text @click="submitItem" :disabled="!validForm">{{ $t('Global.Companies.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "CompanyDialog",
    props: {
      activate: {
          type: Boolean,
          default: false
      },
      item: {
          type: Object,
          default: null
      }
    },
    data() {
      return {
        editedItem: {
          name: "",
          description: "",
          xsiCompanyId: "",
          xsiServiceType: "",
          licenceExpiration: "",
          licenseTypeId: "",
          email: "",
          fsCode: ""
        },
        defaultItem: {
          name: "",
          description: "",
          xsiCompanyId: "",
          xsiServiceType: "",
          licenceExpiration: "",
          licenseTypeId: "",
          email: "",
          fsCode: "",
          enabled: true
        },
        licenceTypeList: [],
        xsiServiceTypeList: [],
        requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
        validEmail: v => v == null || v === "" || !!v.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/) ? true : this.$t('Global.FormRules.invalidFormat'),
        limitTo45: v => v.length <= 45 ? true : this.$t('Global.FormRules.characterLimit'),
        limitTo50: v => v.length <= 50 ? true : this.$t('Global.FormRules.characterLimit'),
        validNameCompany: v => v == null || v === "" || !!v.match(/^[A-Za-z0-9_-]{3,}$/) ? true : this.$t('Global.FormRules.nameCompanyAlphaNumeric'),
        validFsCode: v => v == null || v === "" || !!v.match(/^\d{4}$/) ? true : this.$t('Global.FormRules.fsCodeNumeric'),
        validForm: false

      }
    },
    computed: {
      ...mapGetters(['getDefsLicenceTypes', 'getDefsServicesXsiTypes']),
      formTitle() {
        return !this.item ? this.$t('Global.Companies.newCompany') : this.$t('Global.Companies.editCompany');
      }
    },
    methods: {
      validate() {
        this.validForm = this.$refs.companyForm.validate()
      },
      closeDialog() {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.$emit('close-dialog')
      },
      submitItem() {
        for (const prop in this.editedItem ) {
            if (this.editedItem[prop] === null) this.editedItem[prop] = ""
        }
        if (this.item)
            this.$emit('update-item', this.editedItem)
        else
            this.$emit('create-item', this.editedItem)
        this.closeDialog()
      }
    },
    mounted(){
      this.licenceTypeList = this.getDefsLicenceTypes
      this.xsiServiceTypeList = this.getDefsServicesXsiTypes
        if (this.item) {
            this.editedItem = Object.assign({}, this.item)
        }
        else
            this.editedItem = Object.assign({}, this.defaultItem)
    }
}
</script>
